module.exports = __webpack_public_path__ + "static/media/webinar_selling_formula.09bcd74a.jpg";